import React from 'react';
import { motion } from 'framer-motion';
const images = [{
  id: 1,
  className: 'col-span-12 md:col-span-8 aspect-[16/9] bg-food-2',
  caption: 'אווירה אינטימית'
}, {
  id: 2,
  className: 'col-span-12 md:col-span-4 aspect-[4/5] bg-food-1',
  caption: 'חומרי גלם מקומיים'
}, {
  id: 3,
  className: 'col-span-12 md:col-span-4 aspect-[4/5] bg-food-3 md:-mt-24',
  caption: 'טכניקות מסורתיות'
}, {
  id: 4,
  className: 'col-span-12 md:col-span-8 aspect-[16/9] bg-food-2',
  caption: 'יצירה על צלחת'
}];
export function Gallery() {
  return <section id="gallery" className="py-32 bg-espresso" dir="rtl" data-id="element-46">
      <div className="container mx-auto px-6 md:px-12" data-id="element-47">
        <div className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8" data-id="element-48">
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} data-id="element-49">
            <h2 className="font-serif text-5xl md:text-6xl text-cream mb-4" data-id="element-50">
              גלריה
            </h2>
            <div className="w-16 h-[1px] bg-gold" data-id="element-51" />
          </motion.div>

          <motion.p className="font-sans text-cream/60 max-w-sm text-lg" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2
        }} data-id="element-52">
            הצצה אל מאחורי הקלעים של המטבח שלנו, אל המנות ואל החלל המעוצב
            בקפידה.
          </motion.p>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-8" data-id="element-53">
          {images.map((img, idx) => <motion.div key={img.id} className={`${img.className} relative group overflow-hidden rounded-sm`} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 1,
          delay: idx * 0.15
        }} data-id="element-54">
              <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-700 z-10" data-id="element-55" />

              {/* Simulated Image Content */}
              <div className={`w-full h-full ${img.className.split(' ').find(c => c.startsWith('bg-'))} transform group-hover:scale-105 transition-transform duration-1000 ease-out`} data-id="element-56">
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-60" data-id="element-57" />
              </div>

              <div className="absolute bottom-0 right-0 p-6 z-20 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500" data-id="element-58">
                <span className="font-serif text-xl text-cream" data-id="element-59">
                  {img.caption}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}